import * as yup from "yup";

yup.addMethod(yup.array, "unique", function unique(message: string, mapper = (a: any) => a, filter = (a: any) => a) {
	return this.test("unique", message, (list) => {
		if(!list)
			return true;

		let listChanged = list;

		if(filter)
			listChanged = listChanged.filter(filter);

		if(!listChanged || (listChanged && listChanged.length === 0))
			return true;
		
		return listChanged.length === new Set(listChanged.map(mapper)).size;
	});
});

export default yup;
